import { apiEndpoints } from "@/services/api/api";
import { defer, LoaderFunctionArgs, redirect } from "react-router-dom";
import { authService } from "@/services/auth/authService";

export async function lectureLoader({ params }: LoaderFunctionArgs) {
  const { courseId, lectureId } = params;

  if (!courseId || !lectureId) {
    throw new Error("Course ID and Lecture ID are required");
  }

  const isAuthenticated = !!authService.getAccessToken();

  try {
    // Backend zaten authorization kontrolü yapıyor
    // courseSidebar'da CourseProgress ve IsCompleted fieldları
    // sadece authorized kullanıcılar için doluyor
    const [lectureContent, courseSidebar] = await Promise.all([
      isAuthenticated
        ? apiEndpoints.getLectureContent(lectureId)
        : apiEndpoints.getPublicLectureContent(lectureId),
      isAuthenticated
        ? apiEndpoints.getCourseSidebarData(courseId)
        : apiEndpoints.getPublicCourseSidebarData(courseId),
    ]);

    // API başarısız olursa (success: false)
    if (!lectureContent.success) {
      throw new Response(lectureContent.message || "Ders içeriği yüklenemedi", {
        status: 500,
      });
    }

    if (!courseSidebar.success) {
      throw new Response(courseSidebar.message || "Kurs içeriği yüklenemedi", {
        status: 500,
      });
    }

    const hasFullAccess = courseSidebar.data.courseProgress !== null;
    const isPublic = lectureContent.data.isPublic;

    // Kullanıcının içeriğe erişimi var mı kontrol et
    const canAccessContent = hasFullAccess || isPublic;

    // HTML içeriğini blob'dan çek - sadece erişimi varsa

    if (canAccessContent && lectureContent.data.content?.url) {
      try {
        const bookmarkContents = isAuthenticated
          ? await apiEndpoints.getAllBookmarkGroups()
          : null;
        const htmlContentPromise = apiEndpoints.getHtmlFromBlob(
          lectureContent.data.content.url,
        );
        return defer({
          canAccessContent: true as const,
          lectureId,
          lectureContent: lectureContent.data,
          htmlContent: htmlContentPromise,
          courseSidebar: courseSidebar.data,
          bookmarkContents: bookmarkContents?.data ?? null,
          hasFullAccess,
          isAuthenticated,
        });
      } catch (error) {
        console.error("HTML content yüklenirken hata:", error);
        // HTML yüklenemese bile devam et, component'te hata gösteririz
      }
    }

    return {
      canAccessContent: false as const,
      lectureId,
      lectureContent: lectureContent.data,
      courseSidebar: courseSidebar.data,
      hasFullAccess,
      isAuthenticated,
    };
  } catch (error) {
    return redirect(`/course/${courseId}`);
  }
}
